export function getInitials(first?: string, last?: string): string {
    if (!first && !last) return "";
    const f = first?.charAt(0) ?? "";
    const l = last?.charAt(0) ?? "";
    return (f + l).toUpperCase();
}